import { render, staticRenderFns } from "./TeacherPageTableControl.vue?vue&type=template&id=0b7d202e&scoped=true&"
import script from "./TeacherPageTableControl.vue?vue&type=script&lang=js&"
export * from "./TeacherPageTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7d202e",
  null
  
)

export default component.exports